(function () {
  angular.module("tikonApp").factory("ProgressBarService", ProgressBarService);
  ProgressBarService.$inject = ["$http", "$timeout"]

  function ProgressBarService($http, $timeout) {
    var loading_screen = null;
    var isProgressOpen = false;

    function isLoading() {
      if ($http.pendingRequests.length > 0) {
        var postRequest = $http.pendingRequests.filter(function (req) {
          return req.method !== "GET";
        });
        return postRequest.length > 0;
      }
      return false;
    }

    function show() {
      if (isProgressOpen) return loading_screen;

      isProgressOpen = true;

      var html =
        "<div>" +
        '<span translate="messages.pleaseWait" > لطفا منتظر باشید...</span>' +
        "</div>" +
        '    <div class="sk-wave"> ' +
        '<div class="sk-rect sk-rect1"></div> ' +
        '<div class="sk-rect sk-rect2"></div> ' +
        '<div class="sk-rect sk-rect3"></div>' +
        ' <div class="sk-rect sk-rect4"></div> ' +
        '<div class="sk-rect sk-rect5"></div> ' +
        '<div class="sk-rect sk-rect6"></div> ' +
        '<div class="sk-rect sk-rect7"></div> ' +
        "</div>";

      loading_screen = pleaseWait({
        logo: "/content/images/logo.png",
        loadingHtml: html,
      });

      $timeout(hide, 5000);

      return loading_screen;
    }

    function hide() {
      if (loading_screen) {
        loading_screen.finish();
        isProgressOpen = false;
      }
    }

    return {
      show: show,
      hide: hide,
      isLoading: isLoading,
    };
  }
})();
